<template>
  <div class="excel-export-container">
    <el-page-header content="业务汇总表_报表导出" />
    <el-card class="export-card" shadow="hover">
      <div class="query-section">
        <!-- 导出按钮区域：支持快速导出完整业务汇总表 -->
        <el-form :inline="true" class="export-query-form">
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-download"
              @click="exportBusinessSummaryExcel"
              :loading="isExporting"
              size="medium"
            >
              导出业务汇总表_报表（含13个Sheet）
            </el-button>
          </el-form-item>
        </el-form>

        <!-- 业务汇总表专属提示：明确包含的工作表类型 -->
        <div class="export-tip">
          <i class="el-icon-info"></i>
          温馨提示：导出文件与“业务汇总表_报表.xlsx”结构完全一致，包含13个工作表（号码对应的业务、业务搭载不合规报表、免费卡充值表、房补积分表等），导出格式为.xlsx，数据实时从业务汇总落地表查询。<br/>
          <span style="color:#f56c6c;font-size:12px;">若未自动下载，请检查浏览器下载弹窗拦截；建议导出后核对工作表数量，确保数据完整性</span>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import service from '@/utils/request'

export default {
  name: 'BusinessSummaryExcelExport',
  data() {
    return {
      isExporting: false // 导出加载状态：防止重复点击
    }
  },
  methods: {
    /**
     * 业务汇总表_报表导出核心方法
     * 适配业务汇总落地表（t_business_summary_landing）数据，生成13个Sheet的Excel文件
     */
    async exportBusinessSummaryExcel() {
      this.isExporting = true
      try {
        // 1. 调用业务汇总表专属导出接口，携带批次标识确保数据全量
        const response = await service.get(
          'excel/export/business-summary', // 业务汇总表导出接口（对应落地表查询）
          {
            timeout: 900000, // 15分钟超时：适配13个Sheet的大数据量导出
            responseType: 'blob', // 强制二进制流响应，避免文件乱码
            headers: {
              'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            params: {
              batchType: 'full' // 全量导出标识：匹配落地表batch_no逻辑
            }
          }
        )

        // 2. 验证文件有效性：过滤空文件（业务汇总表空文件多为批次数据异常）
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        })
        if (blob.size < 100) {
          this.$message.error('导出失败：业务汇总落地表无有效数据，或当前批次数据异常');
          return;
        }

        // 3. 生成与原文件匹配的文件名：带时间戳区分版本（如“业务汇总表_报表_20260201143000.xlsx”）
        const now = new Date()
        const timeStr = `${now.getFullYear()}` + 
          `${(now.getMonth() + 1).toString().padStart(2, '0')}` + 
          `${now.getDate().toString().padStart(2, '0')}` + 
          `${now.getHours().toString().padStart(2, '0')}` + 
          `${now.getMinutes().toString().padStart(2, '0')}` + 
          `${now.getSeconds().toString().padStart(2, '0')}`
        const fileName = `业务汇总表_报表_${timeStr}.xlsx`

        // 4. 双兜底下载逻辑：确保不同浏览器环境下都能正常下载
        const downloadUrl = window.URL.createObjectURL(blob)
        
        // 主方案：a标签模拟点击（兼容性更好）
        const link = document.createElement('a')
        link.href = downloadUrl
        link.download = fileName
        link.style.visibility = 'hidden'
        document.body.appendChild(link)
        link.dispatchEvent(new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        }))

        // 5. 延迟清理资源：避免DOM和URL对象内存泄漏
        setTimeout(() => {
          document.body.removeChild(link)
          window.URL.revokeObjectURL(downloadUrl)
        }, 2000)

        // 兜底方案：1秒后检查下载状态，失败则用window.open重试
        setTimeout(() => {
          if (!document.querySelector(`a[href="${downloadUrl}"]`)) {
            window.open(downloadUrl, '_blank')
          }
        }, 1000)

        // 导出成功提示：明确告知包含13个工作表
        this.$message.success('业务汇总表_报表导出成功！包含13个工作表，若未自动下载，请检查浏览器下载弹窗拦截～')

      } catch (error) {
        // 6. 多层级错误捕获：精准定位问题类型
        console.error('业务汇总表导出错误详情：', error);
        if (error.response) {
          this.$message.error(`导出失败：接口返回${error.response.status}错误（${error.response.statusText}），请检查落地表连接`);
        } else if (error.request) {
          this.$message.error('导出失败：网络不通，未收到后端响应，请检查数据库连接与接口服务');
        } else if (error.message.includes('config')) {
          this.$message.error('导出失败：请求配置异常，请核对业务汇总表导出接口地址');
        } else {
          this.$message.error(`导出失败：${error.message || '未知错误'}，建议检查落地表数据格式`);
        }
      } finally {
        // 7. 无论成功失败，关闭加载状态
        this.isExporting = false
      }
    }
  }
}
</script>

<style scoped>
/* 保持与原模板一致的样式，确保页面风格统一 */
.excel-export-container {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: calc(100vh - 120px);
}
.export-card {
  padding: 30px;
}
.query-section {
  margin-bottom: 20px;
}
.export-query-form {
  margin-bottom: 15px;
}
.export-tip {
  padding: 10px 15px;
  background-color: #e6f7ff;
  border-radius: 6px;
  color: #1890ff;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.6;
}
.export-tip .el-icon-info {
  margin-right: 8px;
  font-size: 16px;
  vertical-align: middle;
}
</style>